import React from 'react';

/**
 * What a row's management credentials are called on screen.
 *
 * Two screens ask this and they used to answer it with the same eleven lines
 * copied into each: userManagement.js under the heading `Permissões`, and
 * userData.js under `Credenciais de Gestão`. Copied logic answers differently
 * the moment one copy is edited, which is how the superuser case below survived
 * in one of them.
 *
 * ⚠️ `superuser` and `administrator` are two independent booleans on the model -
 * being a superuser does not set `administrator`. Reading only `administrator`
 * therefore calls a superuser an ordinary `Utilizador`, which is the opposite of
 * true. In reachok_ab_head that is 22 of the 196 users.
 *
 * The wrong label was reachable on `Dados utilizador` only: that screen shows
 * the logged-in user, so a superuser reads their own row there. The users table
 * never showed it, because GET /users/ filters superusers out (api/views.py) -
 * but the label being right does not depend on that filter staying, and this way
 * it no longer does.
 *
 * The values arrive as real JSON booleans from the serializer; the strings are
 * kept because material-table hands its `lookup` values back as strings while a
 * row is being edited.
 */
const isTrue = value => value === true || value === 'true';
const isFalse = value => value === false || value === 'false';

export const renderManagementCredentials = rowData => {
  if (isTrue(rowData.superuser) || isTrue(rowData.administrator)) {
    return <span style={{ color: 'blue' }}>Administrador</span>;
  }
  if (isFalse(rowData.administrator)) {
    return <span style={{ color: 'grey' }}>Utilizador</span>;
  }
  // Undefined rather than false: a row still being added has no value yet, and
  // the original returned nothing here too.
  return undefined;
};

export default renderManagementCredentials;
